import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from '../../core/api.service';

export interface TermAcceptanceDto {
    id: string;
    fornecedorId: string;
    fornecedorNome: string;
    usuarioId: string;
    usuarioEmail: string;
    protocoloAceite: string;
    versaoContrato: string;
    hashContrato?: string;
    termoHash?: string;
    dataAceite: string;
    ipOrigem: string;
    ipForwardedFor?: string;
    userAgent?: string;
    createdAt: string;
}

export interface PaginatedResult<T> {
    items: T[];
    totalItems: number;
    page: number;
    pageSize: number;
    totalPages: number;
}

@Injectable({
    providedIn: 'root'
})
export class TermAcceptanceService {
    constructor(private api: ApiService) { }

    listarAceites(params: {
        page?: number;
        pageSize?: number;
        orderBy?: string;
        orderDirection?: 'asc' | 'desc';
        fornecedorId?: string;
        versaoContrato?: string;
    } = {}): Observable<PaginatedResult<TermAcceptanceDto>> {
        const p = {
            page: 1,
            pageSize: 20,
            orderBy: 'dataAceite',
            orderDirection: 'desc',
            ...params
        };
        return this.api.get('/admin/term-acceptances', p);
    }

    getAceiteById(id: string): Observable<TermAcceptanceDto> {
        return this.api.get(`/admin/term-acceptances/${id}`);
    }

    getHistoricoFornecedor(fornecedorId: string): Observable<{
        fornecedorId: string;
        totalItems: number;
        items: TermAcceptanceDto[];
    }> {
        return this.api.get(`/admin/fornecedores/${fornecedorId}/term-acceptances`);
    }

    getAuditTrail(id: string): Observable<any> {
        return this.api.get(`/admin/term-acceptances/${id}/audit-trail`);
    }
}
